import styled, { css } from 'styled-components';
import { media, remCalc } from 'src/components/base';
import { Link } from 'react-router-dom';

export const CategoryImage = styled.img`
  margin-right: 10px;
  width: 34px;
  height: 34px;
  ${media.mediumUp`
    width: 46px;
    height: 46px;
  `}

  /* stylelint-disable */
  image-rendering: -webkit-optimize-contrast;
  transform: translateZ(0);
`;

export const StyledCategoryList = styled.ul<IStyledCategoryList>`
  display: flex;
  justify-content: ${p => (p.$few ? 'flex-start' : 'space-between')};
  flex-wrap: wrap;
  padding: 0;
  list-style: none;
  margin-bottom: 0;

  &::after {
    ${media.mediumUp`
        content: '';
        flex: 0 0 45%;
        margin-right: 4%;
        order: 9999;
      `}

    ${media.largeUp`
      flex: 0 0 28%;
      `}
  }
`;

export const TopLevelName = styled.span`
  display: block;
  font-size: ${remCalc(14)};
`;

export const TopLevelIcon = styled.div`
  margin-left: auto;
  ${media.mediumUp`
    display: none;
  `}
`;
const transitionDelay = css`
  transition-delay: 0.2s;
`;
export const TopLevelItem = styled.li<ITopLevelItem>(
  props => css`
    position: relative;
    list-style: none;
    flex: 0 0 100%;
    padding: 0;
    margin: 0;

    ${media.mediumUp`
      flex: 0 0 45%;
      margin: 5px 4% 5px 0;

      &::before {
        content: '';
        position: absolute;
        opacity: 0;
        top: 0;
        width: 100%;
        height: 100%;
        border: 1px solid ${props.theme.colors.base200};
        border-radius: 5px;
        z-index: -1;
      }

      &:hover {
          > ${SubLevelList} {
              opacity: 1;
              transition: opacity 0, visibility 0;
              ${transitionDelay};
              visibility: visible;
              background: ${props.theme.bg.primary};
              width: 100%;
              box-shadow: 0 5px 10px -3px rgba(0, 0, 0, 0.1);
              border: 1px solid ${props.theme.colors.base200};
              border-top: none;
              border-radius: 0 0 5px 5px;
              padding: 0 15px 15px 15px;
              z-index: 1;
          }
          &::before {
              opacity: 1;
              transition: opacity 0s;
          }
      }

      ${props.$hasChildren &&
        css`
          &::before {
            /* Remove the bottom border as the list of sub-categories constitutes the "bottom" of the box */
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
            border-bottom: none;
          }
          &:hover::before {
            ${transitionDelay};
          }
        `}
  `}

    ${media.largeUp`
      flex: 0 0 28%;
      margin: 5px 4% 5px 0;
  `}
  `
);

export const AdItem = styled(TopLevelItem)`
  order: 4;
  flex-basis: 100%;
  margin: 0;
  list-style: none;

  ${media.mediumUp`
    order: 99;
    display: none;
  `};

  > *:not(:empty) {
    margin: 5px 0;
  }
`;

export const SubLevelItem = styled.li`
  list-style: none;
`;

export const SubLevelItemShowAll = styled.li`
  list-style: none;
  + ${SubLevelItem} {
    margin-top: 10px;
  }
`;

const linkStyles = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0;
  padding: 7px 0;

  :hover {
    color: ${p => p.theme.text.linkInternalHover};
  }

  ${media.mediumUp`
    padding: 10px;
  `}
`;

export const TopLevelLink = styled(Link)`
  ${linkStyles}
`;

export const SubLevelLink = styled(Link)`
  display: block;
  padding: 2px 0;
  color: ${p => p.theme.text.linkInternal};

  &:hover {
    color: ${p => p.theme.text.linkInternalHover};
  }
`;

export const SubLevelList = styled.ul`
  margin: 0;
  display: none;

  ${media.mediumUp`
    display: block;
    position: absolute;
    background: ${p => p.theme.bg.primary};
    top: 100%;
    z-index: 1;
    visibility: hidden;
    opacity: 0;
  `}
`;

interface IStyledCategoryList {
  $few: boolean;
}

interface ITopLevelItem {
  $hasChildren: boolean;
}
